import type { CSSProperties } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import type { SnackbarOrigin } from '@mui/material/Snackbar';

type DocumentListStyleMap = {
    rowContent: SxProps<Theme>
    rowNameContainer: SxProps<Theme>
    rowMeta: SxProps<Theme>
    rowMetaDate: SxProps<Theme>
    deletingProgress: SxProps<Theme>
    rootGroupContainer: SxProps<Theme>
    groupContainer: SxProps<Theme>
    groupHeader: SxProps<Theme>
    loadingContainer: SxProps<Theme>
    groupedContent: SxProps<Theme>
    simpleListContent: SxProps<Theme>
    sectionHeader: SxProps<Theme>
    sectionContent: SxProps<Theme>
    rootContainer: SxProps<Theme>
    uploadButtonRow: SxProps<Theme>
};

export const documentListStyles: DocumentListStyleMap = {
    rowContent: { display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 },
    rowNameContainer: { minWidth: 0 },
    rowMeta: { display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0, ml: 1 },
    rowMetaDate: { mr: 0.5 },
    deletingProgress: { ml: 0.5 },
    rootGroupContainer: { display: 'flex', flexDirection: 'column', gap: 0.5 },
    groupContainer: { borderLeft: '2px solid', borderColor: 'divider', pl: 1.5 },
    groupHeader: { display: 'flex', alignItems: 'center', gap: 1, py: 0.75, cursor: 'pointer', userSelect: 'none' },
    loadingContainer: { display: 'flex', justifyContent: 'center', py: 4 },
    groupedContent: { display: 'flex', flexDirection: 'column', gap: 1.5 },
    simpleListContent: { display: 'flex', flexDirection: 'column', gap: 0.5 },
    sectionHeader: { px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    sectionContent: { px: 3, py: 2.5 },
    rootContainer: { display: 'flex', flexDirection: 'column', gap: 1.5 },
    uploadButtonRow: { display: 'flex', justifyContent: 'flex-end' },
};

export const imageFileIconColor = '#3b82f6';
export const pdfFileIconColor = '#ef4444';
export const defaultFileIconColor = '#9e9e9e';

export const fileIconStyle: CSSProperties = {
    flexShrink: 0,
};

export const folderChevronStyle: CSSProperties = {
    marginLeft: 'auto',
};

export const getDocumentRowStyles = (): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 1.5,
    py: 1,
    borderRadius: 1,
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': { bgcolor: 'grey.50' },
});

export const getDocumentDeleteActionStyles = (): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    color: '#bdbdbd',
    '&:hover': { color: 'error.main' },
    cursor: 'pointer',
    ml: 0.5,
});

export const documentListSnackbarAnchorOrigin: SnackbarOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
};
